@import '~style-sheet-helpers/core.less';
@import '../../../../constants/spacing.module.less';

.bold {
  font-weight: @bold;
}

.error-block {
  padding: @space-4 @space-8 @space-24;
  background-color: var(--default--background-color--4);
}

.clipboard-button-container {
  width: 100%;
  justify-content: flex-end;
}

.error-values {
  display: flex;
  flex-direction: column;
  max-height: 30vh;
  overflow-y: scroll;
}

.error-key {
  font-weight: @semi-bold;
}

.error-value {
  margin-left: @space-4;
}
